import { MouseEvent } from 'react';

/**
 * 버튼 클릭 시 리플 효과 (물결)
 */
export const useRipple = () => {
  const createRipple = (event: MouseEvent<HTMLElement>) => {
    const button = event.currentTarget;
    const ripple = document.createElement('span');
    
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;
    
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.classList.add('ripple');
    
    button.appendChild(ripple);
    
    setTimeout(() => {
      ripple.remove();
    }, 600);
  };
  
  return createRipple;
};

/**
 * 버튼 펑! 효과
 */
export const usePop = () => {
  const triggerPop = (element: HTMLElement | null) => {
    if (!element) return;
    
    element.classList.remove('animate-pop');
    void element.offsetWidth; // 리플로우 강제
    element.classList.add('animate-pop');
    
    setTimeout(() => {
      element.classList.remove('animate-pop');
    }, 300);
  };
  
  return triggerPop;
};
